/**
 * Plush infinite scroll for the blog listing.
 *
 * Same progressive enhancement as the collection grid (plush-infinite-scroll.js),
 * scoped to .main-blog: when the pagination scrolls into view the next page is
 * fetched and its article cards are appended to .blog-articles. The numbered
 * pagination is hidden while auto-loading and revealed again if a fetch fails.
 */
(function () {
  'use strict';

  var ROOT = '.main-blog';
  var GRID = '.blog-articles';

  function getNextUrl(wrapper) {
    if (!wrapper) return null;
    // Dawn quirk (same as the collection grid): paginate.next renders with the
    // class `pagination__item--prev`. No link = last page = stop.
    var next = wrapper.querySelector('a.pagination__item--prev');
    return next ? next.getAttribute('href') : null;
  }

  function init() {
    var root = document.querySelector(ROOT);
    if (!root) return;

    var grid = root.querySelector(GRID);
    var wrapper = root.querySelector('.pagination-wrapper');
    if (!grid || !wrapper) return;

    var nextUrl = getNextUrl(wrapper);
    if (!nextUrl) return; // single page

    var loading = false;
    var visited = {};

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !loading) loadNext();
        });
      },
      { rootMargin: '400px 0px' }
    );
    observer.observe(wrapper);
    wrapper.classList.add('pagination-wrapper--auto');

    function stop() {
      observer.disconnect();
      if (wrapper.parentNode) wrapper.remove();
    }

    function loadNext() {
      if (!nextUrl || visited[nextUrl]) {
        stop();
        return;
      }
      visited[nextUrl] = true;
      loading = true;
      wrapper.setAttribute('aria-busy', 'true');

      fetch(nextUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Network error');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector(ROOT + ' ' + GRID);
          var newWrapper = doc.querySelector(ROOT + ' .pagination-wrapper');

          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (item) {
              var card = item.cloneNode(true);
              // Drop the scroll-reveal classes: appended cards are already past
              // the trigger point and would otherwise stay invisible.
              card.classList.remove('scroll-trigger', 'animate--slide-in');
              card.removeAttribute('data-cascade');
              card.removeAttribute('style');
              grid.appendChild(card);
            });
          }

          nextUrl = getNextUrl(newWrapper);
          if (nextUrl && !visited[nextUrl]) {
            loading = false;
            wrapper.removeAttribute('aria-busy');
            observer.unobserve(wrapper);
            observer.observe(wrapper);
          } else {
            stop();
          }
        })
        .catch(function () {
          // Fail open: show the real pagination again.
          loading = false;
          wrapper.classList.remove('pagination-wrapper--auto');
          wrapper.removeAttribute('aria-busy');
          observer.disconnect();
        });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
